export function edit_tname_click(editBut:HTMLElement, event:JQuery.ClickEvent) {
	let $tripCard:JQuery<HTMLElement> = $(editBut).parentsUntil(".card").parent();
	$tripCard.find(".tname").removeClass("d-flex");
	$tripCard.find(".tname").hide();
	$tripCard.find(".editTnameForm").show();
	$tripCard.find(".editTnameForm").addClass("d-flex");
};

export function close_edit_tname(editBut:HTMLElement) {
	let $tripCard:JQuery<HTMLElement> = $(editBut).parentsUntil(".card").parent();
	$tripCard.find(".tname").addClass("d-flex");
	$tripCard.find(".tname").show();
	$tripCard.find(".editTnameForm").hide();
	$tripCard.find(".editTnameForm").removeClass("d-flex");
};

export function close_edit_tdesc(editBut:HTMLElement) {
	let $tripCard:JQuery<HTMLElement> = $(editBut).parentsUntil(".card").parent();
	$tripCard.find(".tdesc").addClass("d-flex")
	$tripCard.find(".tdesc").show();
	$tripCard.find(".editTdescForm").hide();
	$tripCard.find(".editTdescForm").removeClass("d-flex");
};

export function edit_tdesc_click(editBut:HTMLElement, event:JQuery.ClickEvent) {
	let $tripCard:JQuery<HTMLElement> = $(editBut).parentsUntil(".card").parent();
	$tripCard.find(".tdesc").removeClass("d-flex")
	$tripCard.find(".tdesc").hide();
	if ($tripCard.find(".tdesc > [tripDescription='']").html().trim() != "No Description") {
		$tripCard.find(".editTdescForm div[contenteditable='true']").html($tripCard.find(".tdesc > [tripDescription='']").html())
	};
	$tripCard.find(".editTdescForm").show();
	$tripCard.find(".editTdescForm").addClass("d-flex");
};